import { useEffect } from "react";
import Routes from "./routes";
import { GoogleOAuthProvider } from "@react-oauth/google";

// Import Scss
import "./assets/scss/themes.scss";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import config from "./config";
import "bootstrap/dist/css/bootstrap.min.css";
import { HelmetProvider } from "react-helmet-async";

const stripePromise = loadStripe(config.get("STRIPE_KEY"));

function App() {
    useEffect(() => {
        if (Notification.permission !== "granted") {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    console.log("Notification permission granted.");
                }
            });
        }
    }, []);

    return (
        <GoogleOAuthProvider clientId={"559514774494-87siar1dedsdc1dp87t8uv4b7f93kgih.apps.googleusercontent.com"}>
            <HelmetProvider>
                <Elements stripe={stripePromise}>
                    <Routes />
                </Elements>
            </HelmetProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
